import ApiService from './api.service.js'
import { versionMajorMinor } from 'typescript'

const API_ACTION = 'contact-info'
const API_ENDPOINT = process.env.VUE_APP_OPPREG_API

const ContactinfoService = {
  getById: async function (id, callback) {
    try {
      let contactParams = {
        params: {
          action: API_ACTION,
          Id: id
        }
      }
      let contactResponse = await ApiService.get(API_ENDPOINT, contactParams)
      if (contactResponse.data.length) {
        callback(contactResponse.data[0])
      }
    } catch (error) {
      
    }
  },
  getByEmail: async function (email, callback) {
    try {
      let contactParams = {
        params: {
          action: API_ACTION,
          Contact_Email: email
        }
      }
      let contactResponse = await ApiService.get(API_ENDPOINT, contactParams)
      if (contactResponse.data.length) {
        callback(contactResponse.data[0])
      } else {
        callback(null, { error: 'Record not found' })
      }
    } catch (error) {
      console.log(error)
    }
  },
  create: async function (data, callback) { 
    let contactPostBody = {
      action: 'contact-info',
      Contact_First_Name: data.Contact_First_Name,
      Contact_Last_Name: data.Contact_Last_Name,
      Contact_Email: data.Contact_Email,
      Contact_Phone: data.Contact_Phone,
      Contact_Title: data.hasOwnProperty('Contact_Title') ? data.Contact_Title : ''
    }
    let contactPostResponse = await ApiService.post(API_ENDPOINT, contactPostBody)
    
    if (contactPostResponse.data.id) {
      callback(contactPostResponse.data.id)
    } else {
      callback(null, { error: 'Error creating contact' })
    }
  },
  update: async function (data, callback) {
    let contactPostBody = {
      action: 'contact-info',
      Id: data.Id,
      Contact_First_Name: data.Contact_First_Name,
      Contact_Last_Name: data.Contact_Last_Name,
      Contact_Email: data.Contact_Email,
      Contact_Phone: data.Contact_Phone
    }
    let contactPostResponse = await ApiService.put(API_ENDPOINT, contactPostBody)
    if (callback) {
      if (contactPostResponse.data) {
        callback(contactPostResponse.data)
      } else {
        callback(null, { error: 'Error creating contact' })
      }
    }
  }
}

export default ContactinfoService
